import React from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Clients2 = () => {
  // Array of all client data - easily expandable for new clients
  const clients = [
    {
      name: 'Aram Al-Jazeera',
      logo: require("assets/img/Aram.jpeg").default,
      website: 'https://aramaljazeera.com/'
    },
    {
      name: 'Saifan',
      logo: '/saifan-logo.png',
      website: 'https://saifanlb.com/'
    },
    {
      name: 'Evora Fashion',
      logo: '/evora-logo.jpg',
      website: '#'
    },
    {
      name: 'Fitness Garage',
      logo: '/fitness-logo.png',
      website: '#'
    },
    {
      name: 'Tafasil',
      logo: '/tafasil-logo.jpg',
      website: '#'
    },
    {
      name: 'Health Talks',
      logo: '/health-logo.jpg',
      website: '#'
    },
    {
      name: 'DAB BBQ',
      logo: '/dab-logo.jpg',
      website: '#'
    },
    {
      name: 'Delora',
      logo: '/delora-logo.jpg',
      website: '#'
    },
    {
      name: 'A-LWS',
      logo: '/awls-logo.jpg',
      website: '#'
    },
    {
      name: 'GSM Trading',
      logo: '/gsm-logo.jpg',
      website: '#'
    },
    {
      name: 'Tamara Couture',
      logo: require("assets/img/faces/tamara-couture-logo.png").default,
      website: '#'
    },
    {
      name: 'Tamara Sport',
      logo: require("assets/img/faces/tamara-sport-logo.png").default,
      website: '#'
    },
    {
      name: 'Appliqué Clothing Shop',
      logo: require("assets/img/faces/applique-clothing-shop-logo.png").default,
      website: '#'
    },
    {
      name: 'Tapleys Pizza & Parmi',
      logo: require("assets/img/faces/tapleys-pizza-logo.png").default,
      website: 'https://www.facebook.com/share/15JsQYiyL4/?mibextid=wwXIfr'
    },
    {
      name: 'Orca Swimming Academy',
      logo: require("assets/img/faces/orca-swimming-academy-logo.png").default,
      website: '#'
    },
    {
      name: 'Al Safeer Steel',
      logo: require("assets/img/faces/Al Safeer Steel.jpeg").default,
      website: 'https://www.instagram.com/alsafeer.steel?igsh=MW41cnd5MWJqcHk2cw=='
    },
    {
      name: 'LOMENOX',
      logo: require("assets/img/faces/lomenox-logo.png").default,
      website: 'https://www.instagram.com/hinox_home?igsh=MWdzZHBmYWNsNzU2OQ=='
    },
    {
      name: 'BO7 Home Gadgets',
      logo: require("assets/img/faces/bo7-home-gadgets-logo.png").default,
      website: 'https://www.instagram.com/bo7_homegadgets?igsh=Mzg1NzM2bDhxcWd1'
    },
    {
      name: 'AbeBarber',
      logo: require("assets/img/faces/barberlogo.png").default,
      website: '#'
    },
    {
      name: 'IceBit',
      logo: require("assets/img/faces/icebitlogo.png").default,
      website: '#'
    },
    {
      name: 'Salame Store',
      logo: require("assets/img/salame store.jpeg").default,
      website: 'https://www.facebook.com/share/1DMsSZqKHn/?mibextid=wwXIfr'
    },
    {
      name: 'Skala Solutions',
      logo: require("assets/img/faces/SKALA-Logo-Reversed-YELLOW (4).pdf").default,
      website: '#'
    },
    {
      name: 'Choubassy Jewelry',
      logo: require("assets/img/Choubassi Jewelry.jpeg").default,
      website: '#'
    },
    {
      name: 'Faraj Automotive',
      logo: require("assets/img/faces/WhatsApp Image 2025-09-30 at 12.32.01 PM.jpeg").default,
      website: '#'
    },
  ];

  return (
    <div style={{
      padding: '40px 0',
      background: 'rgba(255,255,255,0.1)',
      borderRadius: '20px',
      backdropFilter: 'blur(10px)',
      border: '1px solid rgba(255,255,255,0.2)',
      boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
    }}>
      <Slider
        dots={false}
        infinite={true}
        speed={1000}
        slidesToShow={5}
        slidesToScroll={1}
        autoplay={true}
        autoplaySpeed={2000}
        pauseOnHover={true}
        arrows={false}
        responsive={[
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            }
          }
        ]}
        style={{
          padding: '20px 0'
        }}
      >
        {clients.map((client, index) => (
          <div 
            key={index}
            style={{
              padding: '20px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '120px',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
            onClick={() => {
              if (client.website && client.website !== '#') {
                window.open(client.website, '_blank');
              }
            }}
          >
            <img
              alt={client.name}
              src={client.logo}
              style={{
                width: '80px',
                height: '80px',
                objectFit: 'cover',
                transition: 'all 0.3s ease',
                opacity: 1,
                backgroundColor: 'white',
                padding: '8px',
                borderRadius: '50%',
                border: '3px solid rgba(255,255,255,0.3)'
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'scale(1.1)';
                e.target.style.opacity = '1';
                e.target.style.boxShadow = '0 0 20px rgba(255,255,255,0.5)';
                e.target.style.border = '3px solid rgba(255,255,255,0.8)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'scale(1)';
                e.target.style.opacity = '1';
                e.target.style.boxShadow = 'none';
                e.target.style.border = '3px solid rgba(255,255,255,0.3)';
              }}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Clients2;